import { Navigate, Outlet } from 'react-router-dom';
import { getListMicrositeAdminEntitiesQueryKey, useListMicrositeAdminEntities } from '@cdf/api-client-react';

import { Button } from '@/components/ui/button';

export function RequireMicrositeAdmin() {
  const params = { limit: 1, offset: 0 };
  const query = useListMicrositeAdminEntities(params, { query: { queryKey: getListMicrositeAdminEntitiesQueryKey(params), retry: 1 } });

  if (query.isPending) {
    return <div role="status" className="flex min-h-40 items-center justify-center text-sm text-muted-foreground">Checking entity access…</div>;
  }
  if (query.isError) {
    return (
      <div className="mx-auto max-w-lg rounded-lg border p-6 text-center">
        <h1 className="font-semibold">Microsite access could not be checked</h1>
        <p className="mt-2 text-sm text-muted-foreground">Try the access check again. No entity configuration has been exposed.</p>
        <Button className="mt-4" variant="outline" onClick={() => void query.refetch()}>Retry</Button>
      </div>
    );
  }
  if (!query.data || query.data.total === 0) return <Navigate to="/" replace />;
  return <Outlet />;
}
